import React, { useEffect, useState, useRef } from 'react';

import GlenLogo from '../../assets/images/loading/glen-logo.png';
import GlenLoadingBG from '../../assets/images/loading/glen-loading-bg.webp';

import './style.scss';

const LoadingImage = (props) => {
  const { loaded, onClosing, onClosed } = props;
  // const loadingImage = useMemo(
  //   () => tour.introImageUrl || tour.logoURL || vizionLogo,
  //   [tour]
  // );
  const [enabled, setEnabled] = useState(true);
  const [enableAnimation, setEnabledAnimation] = useState(false);
  const startTimer = useRef(Date.now());
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    if (loaded) {
      (async () => {
        const elapsedTime = Date.now() - startTimer.current;

        if (elapsedTime < 3000) {
          await delay(2000);
        }
        setEnabledAnimation(true);
        await delay(3000);
        onClosing && onClosing();
        setEnabled(false);
        onClosed && onClosed();
      })();
    }
    // eslint-disable-next-line
  }, [loaded]);

  return (
    <>
      {enabled ? (
        <div
          className={`loading-container ${enableAnimation ? 'fade-out' : ''}`}
          style={{
            backgroundImage: `url(${GlenLoadingBG})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="loading-image">
            <img src={GlenLogo} alt="Loading intro" />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default LoadingImage;
